import {MentionFrom} from '@/constants/document/mention';

export interface IMentionItem {
    uuid: string;
    info: {
        [key: string]: any;
    };
    options: {
        [key: string]: any;
        checked?: boolean;
        fromPaste?: boolean;
        from?: MentionFrom;
    };
}

export interface ICacheMap {
    [key: string]: IMentionItem;
}

let cache: ICacheMap = {};
// 存储mention 所在的评论的id
const mentionOnCommentMap: {
    [key: string]: string;
} = {};

const mentionCache = {
    add(data: IMentionItem) {
        cache[data.uuid] = data;
    },
    get(id: string) {
        const mention = cache[id];
        return mention;
    },
    setCommentId(id: string, commentId: string) {
        if (id && commentId) {
            mentionOnCommentMap[id] = commentId;
        }
    },
    getCommentId(id: string) {
        return mentionOnCommentMap[id] || null;
    },
    delete(id: string) {
        delete cache[id];
    },
    reset() {
        cache = {};
    },
};

export default mentionCache;
